import React, { memo } from 'react';
import PropTypes from 'prop-types';

const TableBodyCell = memo(({
  align, children, classes, padding,
}) => <td align={align} padding={padding} className={classes.cell}>{children}</td>);

TableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  align: PropTypes.string,
  padding: PropTypes.string,
};

TableBodyCell.defaultProps = {
  align: 'left',
  padding: 'default',
};

export default TableBodyCell;
